import paginator from '~/helpers/paginator';

export default {
  getAMLChecks: async (data = null, account_uuid) => await paginator.grabAllPages($nuxt.$api.host + '/account/' + account_uuid + '/check', {}, data),
  getAMLCheck: (check_uuid, account_uuid) => $nuxt.$axios.get($nuxt.$api.host + '/account/' + account_uuid + '/check/' + check_uuid),
  createAMLCheck: (data, account_uuid) => $nuxt.$axios.post($nuxt.$api.host + '/account/' + account_uuid + '/check', data),
  updateAMLCheck: (data, check_uuid, account_uuid) => $nuxt.$axios.put($nuxt.$api.host + '/account/' + account_uuid + '/check/' + check_uuid, data),
  deleteAMLCheck: (check_uuid, account_uuid) => $nuxt.$axios.delete($nuxt.$api.host + '/account/' + account_uuid + '/check/' + check_uuid),
}